export const keyCodes = {
    enter: 13,
    space: 32,
    end: 35,
    home: 36,
    escape: 27,
    arrowLeft: 37,
    arrowUp: 38,
    arrowRight: 39,
    arrowDown: 40,
    tab: 9,
    delete: 46,
    a: 65,
    z: 90,
    pageUp: 33,
    pageDown: 34,
};
export const keyboardShortcuts = {
    confirmKey: 'Enter',
    spaceKey: ' ',
    arrowDownKey: 'ArrowDown',
    arrowUpKey: 'ArrowUp',
    escapeKey: 'Escape',
};
// see: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
export const keys = {
    space: ['Spacebar', ' '],
    enter: ['Enter'],
};
function activateByKey(key) {
    return event => {
        if (event.keyCode === key) {
            event.preventDefault();
            event.stopPropagation();
            event.currentTarget.click();
        }
    };
}
export const activateBySpaceButton = activateByKey(keyCodes.space);
export const activateByEnterButton = activateByKey(keyCodes.enter);
export const activateBySpaceOrEnterButton = event => {
    activateByEnterButton(event);
    activateBySpaceButton(event);
};
export const activateByEscapeButton = activateByKey(keyCodes.escape);
export const HAS_CUSTOM_FOCUS_CLASSNAME = 'has-custom-focus';
export const a11yBlackList = ['aria-id', 'aria-metadata', 'aria-type'];
export const filteredA11y = (a11y, blacklist) => {
    return Object.entries(a11y).reduce((acc, [key, value]) => {
        if (!blacklist.includes(key)) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
/**
 * @deprecated use getAccessibilityAttributes instead wherever you can
 */
export const getAriaAttributes = ({ role, tabIndex, tabindex, ...ariaProps } = {}) => {
    const result = Object.entries(ariaProps).reduce((prev, [key, value]) => {
        return { ...prev, [`aria-${key}`.toLowerCase()]: value };
    }, { role, tabIndex: tabIndex ?? tabindex });
    Object.keys(result).forEach(key => {
        if (result[key] === undefined || result[key] === null) {
            // eslint-disable-next-line
            delete result[key];
        }
    });
    return filteredA11y(result, a11yBlackList);
};
export const getTabIndexAttribute = (a11y = {}) => {
    const tabIndex = a11y.tabIndex ?? a11y.tabindex ?? undefined;
    return tabIndex !== undefined ? { tabIndex: Number(tabIndex) } : {};
};
export const getAriaLabelAttribute = (a11y = {}) => {
    return a11y.label ? { 'aria-label': a11y.label } : {};
};
export const INNER_FOCUS_RING_CLASSNAME = 'has-inner-focus-ring';
const LINE1 = '0 0 0 1px';
const LINE2 = '0 0 0 3px';
const COLOR1 = '#ffffff';
const COLOR2 = '#116dff';
const OUTER_FOCUS_RING = `${LINE1}${COLOR1}, ${LINE2}${COLOR2}`;
const INNER_FOCUS_RING = `inset ${LINE1}${COLOR2}, inset ${LINE2}${COLOR1}`;
export const getFocusRingValue = (isOuter = true) => isOuter ? OUTER_FOCUS_RING : INNER_FOCUS_RING;
export const getAccessibilityAttributes = (attributes) => {
    const { role, tabIndex, tabindex, screenReader, lang, ariaAttributes = {}, } = attributes;
    const prefixedAriaAttributes = Object.entries(ariaAttributes).reduce((prev, [key, value]) => {
        return { ...prev, [`aria-${key}`.toLowerCase()]: value };
    }, {});
    return {
        role,
        tabIndex: tabIndex ?? tabindex,
        screenReader,
        ariaAttributes: filteredA11y(prefixedAriaAttributes, a11yBlackList),
        lang,
    };
};
export const getAccessibilityAttributesSpread = (attributes) => {
    const a11yProps = getAccessibilityAttributes(attributes);
    return {
        ...a11yProps.ariaAttributes,
        tabIndex: a11yProps.tabIndex,
        screenReader: a11yProps.screenReader,
        lang: a11yProps.lang,
        role: a11yProps.role,
    };
};
//# sourceMappingURL=a11y.js.map